import React, { FC } from 'react';
import styled from 'styled-components';
import check from './img/check.png';

interface Props {
	text: string;
}

const Container = styled.div`
	position: relative;
	padding-left: 30px;
	font-weight: 400;
	font-size: 16px;
	color: #000;

	& img {
		position: absolute;
		left: 0;
		top: 0px;
	}
`;

export const CourseItem: FC<Props> = props => {
	const { text } = props;
	return (
		<Container>
			<img width={24} height={24} src={check} alt='check img' />
			{text}
		</Container>
	);
};
